import type {MouseEventHandler, ReactElement} from 'react';
import {useState} from 'react';
import type {IconWithTooltipProps} from './icon-with-tooltip.types';
import {TooltipPlacement} from './icon-with-tooltip.types';
import {deriveArrowPositionFromPlacement, getTooltipOverlayClassName} from './icon-with-tooltip-helper';
import styles from './icon-with-tooltip.module.scss';
import {Icon} from '@Components/icon-v2';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export function IconWithTooltip({arrowPosition, tooltipText, tooltipContent, hideArrow = false, placement = TooltipPlacement.TOP, ...props}: IconWithTooltipProps): ReactElement {
  const [show, setShow] = useState(false);
  const resolvedArrowPosition = arrowPosition ?? deriveArrowPositionFromPlacement(placement);
  const tooltipClassName = `${getTooltipOverlayClassName(hideArrow, resolvedArrowPosition)} ${styles.tooltip}`;

  const handleClick: MouseEventHandler = (event): void => {
    setShow(false);
    props.onClick?.(event);
  };

  return (
    <OverlayTrigger
      show={show}
      onToggle={(nextShow: boolean): void => {
        setShow(nextShow);
      }}
      trigger={['hover', 'focus']}
      overlay={<Tooltip className={tooltipClassName}>{tooltipContent ?? tooltipText}</Tooltip>}
      delay={{show: 0, hide: props.toolTipHideDelay ?? 0}}
      placement={placement}
      offset={props.offset ? [props.offset.x, props.offset.y] : undefined}
    >
      <Icon {...props} className={props.className} onClick={handleClick} />
    </OverlayTrigger>
  );
}

